// Central definition of soft / hard media size limits (bytes)
// Adjusting here propagates to minting & future upload guards.

export const mediaLimits = {
  image: { soft: 2 * 1024 * 1024, hard: 10 * 1024 * 1024, absoluteIpfs: 20 * 1024 * 1024 },
  gif: { soft: 5 * 1024 * 1024, hard: 10 * 1024 * 1024 },
  video: { soft: 50 * 1024 * 1024, hard: 250 * 1024 * 1024 },
  audio: { soft: 15 * 1024 * 1024, hard: 50 * 1024 * 1024 },
  metadata: { soft: 100 * 1024, hard: 500 * 1024 },
  galleryImage: { soft: 1 * 1024 * 1024, hard: 5 * 1024 * 1024 },
};

export function formatBytes(bytes, decimals = 2) {
  if (!bytes || bytes < 0) return '0 B';
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

export function classifyImageSize(bytes) {
  const { image } = mediaLimits;
  if (bytes > image.hard) return 'reject';
  if (bytes > image.soft) return 'warn';
  return 'ok';
}

export function shouldAttemptIpfsImagePin(bytes) {
  const { image } = mediaLimits;
  if (bytes > image.absoluteIpfs) return false; // server would reject >20MB anyway
  if (bytes > image.hard) return false; // our client hard cut
  return true;
}
